// extracted by mini-css-extract-plugin
export var addToCartButton = "_ps-b";
export var arrowButtonContainer = "_ps-9";
export var arrowButtonIcon = "_ps-a";
export var carouselArrowButton = "_ps-6";
export var carouselElementContainer = "_ps-1";
export var galleryThumbnail = "_ps-d";
export var galleryThumbnailImage = "_ps-e";
export var left = "_ps-7";
export var productDisplayCarouselContainer = "_ps-0";
export var productTileContainer = "_ps-2";
export var productTileImage = "_ps-4";
export var productTileImageContainer = "_ps-3";
export var productTileTitle = "_ps-5";
export var right = "_ps-8";
export var sliderOverflow = "_ps-c";